import styled from "styled-components"
import Td from "../../ui/SimpleTable/Td"

const StyledTd = styled(Td)`
  padding: 0 !important;
  border-bottom: 0 !important;
`

export default StyledTd
